<script lang="ts" setup>
import {computed} from 'vue'

interface Props {
  width?: string
  height?: string
  radius?: string
  circle?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  width: '100%',
  height: '16px',
  radius: '14px',
  circle: false
})

const skeletonStyle = computed(() => ({
  width: props.width,
  height: props.height,
  borderRadius: props.circle ? '50%' : props.radius
}))
</script>

<template>
  <div class="c-cu-loading"
       :class="{ 'skeleton--circle': circle }"
       :style="skeletonStyle">
  </div>
</template>

<style lang="scss" scoped>
.c-cu-loading {
  background: var(--color-bg-secondary);
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: -150%;
    height: 100%;
    width: 150%;
    background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.5),
            transparent
    );
    animation: shimmer 1.4s infinite;
  }
}

@keyframes shimmer {
  100% {
    left: 150%;
  }
}
</style>